import { getOnlyElementByAttribute } from './getOnlyElementByAttribute';

export const getCheckoutUpsellElement = () => {
  /* Forms */
  const customerInfoForm = getOnlyElementByAttribute(
    '[data-node-type="commerce-checkout-customer-info-wrapper"]'
  ) as HTMLInputElement;

  const additionalCustomerInfoForm = getOnlyElementByAttribute(
    '[data-node-type="commerce-checkout-additional-info"]'
  ) as HTMLInputElement;

  const billingAddressForm = getOnlyElementByAttribute(
    '[data-node-type="commerce-checkout-billing-address-wrapper"]'
  ) as HTMLInputElement;

  const shippingAddressForm = getOnlyElementByAttribute(
    '[data-node-type="commerce-checkout-shipping-address-wrapper"]'
  ) as HTMLInputElement;

  const shippingAddressFormClassList = shippingAddressForm.classList;

  let shippingFormVisible = true;

  shippingAddressFormClassList.forEach((className) => {
    if (className === 'w-condition-invisible') {
      shippingFormVisible = false;
    }
  });

  return {
    customerInfoForm,
    additionalCustomerInfoForm,
    billingAddressForm,
    shippingAddressForm,
    shippingFormVisible,
  };
};
